import React, { useRef, useState } from 'react';

interface VideoPlayerProps {
    src: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        videoRef.current?.play();
    };

    const handlePlayEvent = () => setIsPlaying(true);
    const handlePauseEvent = () => setIsPlaying(false);

    return (
        <div
            className="height-100 overflow-hidden"
            style={{ width: '100%', height: '100%', position: 'relative' }}
        >
            <video
                ref={videoRef}
                controls
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                onPlay={handlePlayEvent}
                onPause={handlePauseEvent}
            >
                <source src={src} type="video/mp4" />
            </video>
            {!isPlaying && (
                <button
                    onClick={handlePlay}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        background: 'rgba(0,0,0,0.3)',
                        border: 'none',
                        borderRadius: '50%',
                        width: 64,
                        height: 64,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 2,
                    }}
                >
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="#fff">
                        <polygon points="10,6 26,16 10,26" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default VideoPlayer;